import {
  NOTIFICATION_TYPES,
  DRAWER_PLACEMENTS,
} from "../../../../../config/constants";
import {
  Empty,
  Select,
  Button,
  Form,
  Input,
  Divider,
  Menu,
  message,
  Popconfirm,
  Spin,
  Drawer,
  Space,
  InputRef,
} from "antd";
import "./MappingTemplate.css";
import {
  CopyOutlined,
  DeleteOutlined,
  FilterFilled,
  ArrowUpOutlined,
  ArrowDownOutlined,
  SearchOutlined,
  CloseOutlined,
  QuestionCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { useEffect, useMemo, useRef, useState } from "react";
import styles from "./MappingTemplate.module.css";
import MappingTemplateService from "../../../../../services/mappingtemplates/MappingTemplatesService";
import Table, { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import Tree, { DataNode, TreeProps } from "antd/lib/tree";
import { ColumnType, FilterConfirmProps } from "antd/lib/table/interface";
import Highlighter from "react-highlight-words";
import Datatable from "../../../../shared/components/Datatable";
import { useTranslation } from "react-i18next";
import NotificationsUtil from "../../../../shared/utils/NotificationsUtil";

enum RowAction {
  View = 1,
  Edit,
  Create,
}

const { Search } = Input;

const MappingTemplate = ({
  mappingTemplates,
  setMappingTemplates,
}: {
  mappingTemplates: any;
  setMappingTemplates: any;
}) => {
  interface DataType {
    key: string;
    id: number;
    fromValue: string;
    toTableId: number;
    toFieldId: number;
    comments: string;
  }

  type DataIndex = keyof DataType;
  const { t, i18n } = useTranslation("translations");

  const { Option } = Select;
  const [isTableLoading, setIsTableLoading] = useState(true);
  const [selectedMappingTemplate, setSelectedMappingTemplate] =
    useState<any>(null);
  const [openDrawer, setOpenDrawer] = useState(false);

  const [drawerTitle, setDrawerTitle] = useState<string>("");
  const [drawerAction, setDrawerAction] = useState<RowAction>();
  const [editedRow, setEditedRow] = useState<any>();

  const [mappingTemplateMappings, setMappingTemplateMappings] = useState<
    DataType[]
  >([]);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);

  const [fromValueSearchValue, setFromValueSearchValue] = useState<string>("");
  const [fromValueFilters, setFromValueFilters] = useState<any>([]);
  const [fromValueCheckedKeys, setFromValueCheckedKeys] = useState<any>([]);
  const [fromValueAscending, setFromValueAscending] = useState(false);
  const [fromValueDescending, setFromValueDescending] = useState(false);

  const [toTableIdSearchValue, setToTableIdSearchValue] = useState<string>("");
  const [toTableIdFilters, setToTableIdFilters] = useState<any>([]);
  const [toTableIdCheckedKeys, setToTableIdCheckedKeys] = useState<any>([]);
  const [toTableIdAscending, setToTableIdAscending] = useState(false);
  const [toTableIdDescending, setToTableIdDescending] = useState(false);

  const [toFieldIdSearchValue, setToFieldIdSearchValue] = useState<string>("");
  const [toFieldIdFilters, setToFieldIdFilters] = useState<any>([]);
  const [toFieldIdCheckedKeys, setToFieldIdCheckedKeys] = useState<any>([]);
  const [toFieldIdAscending, setToFieldIdAscending] = useState(false);
  const [toFieldIdDescending, setToFieldIdDescending] = useState(false);

  const [commentsSearchValue, setCommentsSearchValue] = useState<string>("");
  const [commentsFilters, setCommentsFilters] = useState<any>([]);
  const [commentsCheckedKeys, setCommentsCheckedKeys] = useState<any>([]);
  const [commentsAscending, setCommentsAscending] = useState(false);
  const [commentsDescending, setCommentsDescending] = useState(false);

  const [isMappingTemplateTableLoading, setIsMappingTemplateTableLoading] =
    useState<boolean>(false);

  useEffect(() => {
    if (mappingTemplateMappings) {
      const distinctBy = (prop: any, arr: any) => [
        ...new Set(arr.map((o: any) => o[prop])),
      ];

      let result = distinctBy("fromValue", mappingTemplateMappings);
      setFromValueFilters(
        result.map((value: any, index: any) => ({ key: index, title: value }))
      );

      result = distinctBy("toTableId", mappingTemplateMappings);
      setToTableIdFilters(
        result.map((value: any, index: any) => ({ key: index, title: value }))
      );

      result = distinctBy("toFieldId", mappingTemplateMappings);
      setToFieldIdFilters(
        result.map((value: any, index: any) => ({ key: index, title: value }))
      );

      result = distinctBy("comments", mappingTemplateMappings);
      setCommentsFilters(
        result.map((value: any, index: any) => ({ key: index, title: value }))
      );
    }
  }, [mappingTemplateMappings]);

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const onFromValueFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setFromValueSearchValue(value);
  };

  const onToTableIdFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setToTableIdSearchValue(value);
  };

  const onToFieldIdFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setToFieldIdSearchValue(value);
  };

  const onCommentsFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setCommentsSearchValue(value);
  };

  const fromValueFilterTreeData = useMemo(() => {
    const loop = (fromValueFilters: DataNode[]): DataNode[] =>
      fromValueFilters
        .map((item: any) => {
          const strTitle = item.title as string;
          const index = strTitle.indexOf(fromValueSearchValue);
          const beforeStr = strTitle.substring(0, index);
          const afterStr = strTitle.slice(index + fromValueSearchValue.length);
          const title =
            index > -1 ? (
              <span>
                {beforeStr}
                <span className="site-tree-search-value">
                  {fromValueSearchValue}
                </span>
                {afterStr}
              </span>
            ) : (
              <span>{strTitle}</span>
            );

          return {
            title,
            key: item.key,
            shouldRemove: index === -1,
          };
        })
        .filter((x: any) => !x.shouldRemove);

    return loop(
      fromValueFilters.map((x: any) => ({ key: x.key, title: x.title }))
    );
  }, [fromValueFilters, fromValueSearchValue]);

  const toTableIdFilterTreeData = useMemo(() => {
    const loop = (toTableIdFilters: DataNode[]): DataNode[] =>
      toTableIdFilters
        .map((item: any) => {
          const strTitle = item.title ? item.title.toString() : "";
          const index = strTitle.indexOf(toTableIdSearchValue);
          const beforeStr = strTitle.substring(0, index);
          const afterStr = strTitle.slice(index + toTableIdSearchValue.length);
          const title =
            index > -1 ? (
              <span>
                {beforeStr}
                <span className="site-tree-search-value">
                  {toTableIdSearchValue}
                </span>
                {afterStr}
              </span>
            ) : (
              <span>{strTitle}</span>
            );

          return {
            title,
            key: item.key,
            shouldRemove: index === -1,
          };
        })
        .filter((x: any) => !x.shouldRemove);

    return loop(
      toTableIdFilters.map((x: any) => ({ key: x.key, title: x.title }))
    );
  }, [toTableIdFilters, toTableIdSearchValue]);

  const toFieldIdFilterTreeData = useMemo(() => {
    const loop = (toFieldIdFilters: DataNode[]): DataNode[] =>
      toFieldIdFilters
        .map((item: any) => {
          const strTitle = item.title ? item.title.toString() : "";
          const index = strTitle.indexOf(toFieldIdSearchValue);
          const beforeStr = strTitle.substring(0, index);
          const afterStr = strTitle.slice(index + toFieldIdSearchValue.length);
          const title =
            index > -1 ? (
              <span>
                {beforeStr}
                <span className="site-tree-search-value">
                  {toFieldIdSearchValue}
                </span>
                {afterStr}
              </span>
            ) : (
              <span>{strTitle}</span>
            );

          return {
            title,
            key: item.key,
            shouldRemove: index === -1,
          };
        })
        .filter((x: any) => !x.shouldRemove);

    return loop(
      toFieldIdFilters.map((x: any) => ({ key: x.key, title: x.title }))
    );
  }, [toFieldIdFilters, toFieldIdSearchValue]);

  const commentsFilterTreeData = useMemo(() => {
    const loop = (commentsFilters: DataNode[]): DataNode[] =>
      commentsFilters
        .map((item: any) => {
          const strTitle = item.title ? item.title.toString() : "";
          const index = strTitle.indexOf(commentsSearchValue);
          const beforeStr = strTitle.substring(0, index);
          const afterStr = strTitle.slice(index + commentsSearchValue.length);
          const title =
            index > -1 ? (
              <span>
                {beforeStr}
                <span className="site-tree-search-value">
                  {commentsSearchValue}
                </span>
                {afterStr}
              </span>
            ) : (
              <span>{strTitle}</span>
            );

          return {
            title,
            key: item.key,
            shouldRemove: index === -1,
          };
        })
        .filter((x: any) => !x.shouldRemove);

    return loop(
      commentsFilters.map((x: any) => ({ key: x.key, title: x.title }))
    );
  }, [commentsFilters, commentsSearchValue]);

  useEffect(() => {
    if (mappingTemplateMappings) {
      let newTableItems = mappingTemplateMappings.map((x: any) => {
        return { ...x };
      });
      if (fromValueAscending) {
        setMappingTemplateMappings([
          ...newTableItems.sort((a, b) => (a.fromValue > b.fromValue ? 1 : -1)),
        ]);
      }
      if (fromValueDescending) {
        setMappingTemplateMappings([
          ...newTableItems.sort((a, b) => (a.fromValue < b.fromValue ? 1 : -1)),
        ]);
      }
    }
  }, [fromValueAscending, fromValueDescending]);

  useEffect(() => {
    if (mappingTemplateMappings) {
      let newTableItems = mappingTemplateMappings.map((x: any) => {
        return { ...x };
      });
      if (toTableIdAscending) {
        setMappingTemplateMappings([
          ...newTableItems.sort((a, b) => (a.toTableId > b.toTableId ? 1 : -1)),
        ]);
      }
      if (toTableIdDescending) {
        setMappingTemplateMappings([
          ...newTableItems.sort((a, b) => (a.toTableId < b.toTableId ? 1 : -1)),
        ]);
      }
    }
  }, [toTableIdAscending, toTableIdDescending]);

  useEffect(() => {
    if (mappingTemplateMappings) {
      let newTableItems = mappingTemplateMappings.map((x: any) => {
        return { ...x };
      });
      if (toFieldIdAscending) {
        setMappingTemplateMappings([
          ...newTableItems.sort((a, b) => (a.toFieldId > b.toFieldId ? 1 : -1)),
        ]);
      }
      if (toFieldIdDescending) {
        setMappingTemplateMappings([
          ...newTableItems.sort((a, b) => (a.toFieldId < b.toFieldId ? 1 : -1)),
        ]);
      }
    }
  }, [toFieldIdAscending, toFieldIdDescending]);

  useEffect(() => {
    if (mappingTemplateMappings) {
      let newTableItems = mappingTemplateMappings.map((x: any) => {
        return { ...x };
      });
      if (commentsAscending) {
        setMappingTemplateMappings([
          ...newTableItems.sort((a, b) => (a.comments > b.comments ? 1 : -1)),
        ]);
      }
      if (commentsDescending) {
        setMappingTemplateMappings([
          ...newTableItems.sort((a, b) => (a.comments < b.comments ? 1 : -1)),
        ]);
      }
    }
  }, [commentsAscending, commentsDescending]);

  const onFromValueTreeItemCheck: TreeProps["onCheck"] = (keys, info) => {
    setFromValueCheckedKeys(keys);
  };

  const onToTableIdTreeItemCheck: TreeProps["onCheck"] = (keys, info) => {
    setToTableIdCheckedKeys(keys);
  };

  const onToFieldIdTreeItemCheck: TreeProps["onCheck"] = (keys, info) => {
    setToFieldIdCheckedKeys(keys);
  };

  const onCommentsTreeItemCheck: TreeProps["onCheck"] = (keys, info) => {
    setCommentsCheckedKeys(keys);
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex,
    filterChangeFunc: any,
    data: any,
    checkedKeys: any,
    onTreeItemCheck: any,
    itemsAcending: any,
    itemsDescending: any,
    setItemsAscending: any,
    setItemsDescending: any
  ): ColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        className="tableFilter"
        style={{ padding: "4px 10px", maxWidth: "220px" }}
      >
        <div className="sortingContainer">
          <span>
            {t("General.Labels.Sort", {
              lngs: i18n.languages,
              defaultValue: "Sort",
            })}
          </span>
          <Button
            type="text"
            icon={<ArrowUpOutlined />}
            style={{
              textAlign: "left",
              paddingLeft: "8px",
              backgroundColor: itemsAcending ? "#7BBDB1" : "",
              color: itemsAcending ? "#fff" : "",
            }}
            onClick={() => {
              setItemsAscending(!itemsAcending);
              setItemsDescending(false);
            }}
          >
            Ascending
          </Button>
          <Button
            type="text"
            icon={<ArrowDownOutlined />}
            style={{
              textAlign: "left",
              paddingLeft: "8px",
              backgroundColor: itemsDescending ? "#7BBDB1" : "",
              color: itemsDescending ? "#fff" : "",
            }}
            onClick={() => {
              setItemsDescending(!itemsDescending);
              setItemsAscending(false);
            }}
          >
            Descending
          </Button>
        </div>
        <Divider />
        <Search
          prefix={<SearchOutlined />}
          allowClear
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            filterChangeFunc(e);
            setSelectedKeys(e.target.value ? [e.target.value] : []);
          }}
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "flex" }}
        />
        <Tree
          checkable
          onCheck={onTreeItemCheck}
          checkedKeys={checkedKeys}
          treeData={data}
        />
        <Divider />
        <div className="filterButtons">
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            type="text"
          >
            Reset
          </Button>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            size="small"
          >
            OK
          </Button>
        </div>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <FilterFilled style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns: ColumnsType<DataType> = [
    {
      title: "From Value",
      dataIndex: "fromValue",
      key: "fromValue",
      width: "200px",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      ...getColumnSearchProps(
        "fromValue",
        onFromValueFilterChange,
        fromValueFilterTreeData,
        fromValueCheckedKeys,
        onFromValueTreeItemCheck,
        fromValueAscending,
        fromValueDescending,
        setFromValueAscending,
        setFromValueDescending
      ),
      sorter: (a, b) => a.fromValue.localeCompare(b.fromValue),
    },
    {
      title: "To Table ID",
      dataIndex: "toTableId",
      key: "toTableId",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      ...getColumnSearchProps(
        "toTableId",
        onToTableIdFilterChange,
        toTableIdFilterTreeData,
        toTableIdCheckedKeys,
        onToTableIdTreeItemCheck,
        toTableIdAscending,
        toTableIdDescending,
        setToTableIdAscending,
        setToTableIdDescending
      ),
      sorter: (a, b) => a.toTableId - b.toTableId,
    },
    {
      title: "To Field ID",
      dataIndex: "toFieldId",
      key: "toFieldId",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      ...getColumnSearchProps(
        "toFieldId",
        onToFieldIdFilterChange,
        toFieldIdFilterTreeData,
        toFieldIdCheckedKeys,
        onToFieldIdTreeItemCheck,
        toFieldIdAscending,
        toFieldIdDescending,
        setToFieldIdAscending,
        setToFieldIdDescending
      ),
      sorter: (a, b) => a.toFieldId - b.toFieldId,
    },
    {
      title: "Comments",
      key: "comments",
      dataIndex: "comments",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      ...getColumnSearchProps(
        "comments",
        onCommentsFilterChange,
        commentsFilterTreeData,
        commentsCheckedKeys,
        onCommentsTreeItemCheck,
        commentsAscending,
        commentsDescending,
        setCommentsAscending,
        setCommentsDescending
      ),
      sorter: (a, b) => a.comments.localeCompare(b.comments),
    },
    {
      title: "Actions",
      key: "actions",
      width: "80px",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <a>
            <CopyOutlined />
          </a>
          <a>
            <DeleteOutlined />
          </a>
        </Space>
      ),
    },
  ];

  const showDrawer = (action: RowAction) => {
    setDrawerAction(action);
    switch (action) {
      case RowAction.View:
        setDrawerTitle("Row details");
        break;
      case RowAction.Create:
        setDrawerTitle("New reference");
        break;
      case RowAction.Edit:
        setDrawerTitle("Edit reference");
        break;
      default:
        break;
    }
    setOpenDrawer(true);
  };

  const onClose = () => {
    setOpenDrawer(false);
    setEditedRow(null);
  };

  useEffect(() => {
    if (selectedMappingTemplate) {
      MappingTemplateService.getAllMappings(selectedMappingTemplate.id).then(
        (response: any) => {
          setMappingTemplateMappings(response.data);
          setIsMappingTemplateTableLoading(false);
        }
      );
    }
  }, [selectedMappingTemplate]);

  const handleMappingTemplateChange = (value: string) => {
    setIsMappingTemplateTableLoading(true);
    setSelectedMappingTemplate(
      mappingTemplates.find((x: any) => x.id === value)
    );
  };
  const handleMappingTemplateMenuClick = (e: any) => {
    setIsMappingTemplateTableLoading(true);
    setSelectedMappingTemplate(
      mappingTemplates.find((x: any) => x.id.toString() === e.key)
    );
  };

  const onDeleteMappingTemplate = (id: number) => {
    MappingTemplateService.remove(id)
      .then((response: any) => {
        setMappingTemplateMappings([]);
        setSelectedMappingTemplate(undefined);
        setIsTableLoading(true);
        NotificationsUtil.openNotificationDialog({
          description: t(
            "Page.Operation.LegacyMapping.Tabs.MappingTemplate.Notifications.Mapping.DeleteSuccessDescription",
            {
              lngs: i18n.languages,
              defaultValue: "Mapping template deleted successfully.",
            }
          )!,
          type: NOTIFICATION_TYPES.SUCCESS,
          logError: false,
        });
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          description: error.response.data,
          type: NOTIFICATION_TYPES.ERROR,
          logError: true,
        });
      });
  };

  const cancel = (e: React.MouseEvent<HTMLElement>) => {
    message.error("Click on No");
  };

  useEffect(() => {
    if (isTableLoading) {
      MappingTemplateService.getAll().then((response: any) => {
        const data = response.data;
        setMappingTemplates(data);
        setIsTableLoading(false);
      });
    }
  }, [isTableLoading]);

  const columnsTable: ColumnsType<DataType> = [
    {
      title: "From Value",
      dataIndex: "fromValue",
      key: "fromValue",
    },
    {
      title: "To Table ID",
      dataIndex: "toTableID",
      key: "toTableID",
    },
    {
      title: "To Field ID",
      dataIndex: "toFieldID",
      key: "toFieldID",
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
    },
    {
      title: "Actions",
      key: "actions",
      width: "80px",
      align: "center",
      render: (_, record) => (
        <>
          <Popconfirm
            placement="topRight"
            title="Are you sure to delete this mapping template?"
            icon={<QuestionCircleOutlined style={{ color: "red" }} />}
            onConfirm={() => onDeleteMappingTemplate(record.id)}
            onCancel={() => cancel}
            okText="Yes"
            cancelText="No"
          >
            <Button type="text" size="small" style={{ padding: "0px 2px" }}>
              <DeleteOutlined style={{ color: "var(--primary)" }} />
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  const scroll = { y: "calc(100vh - 380px)" };

  return (
    <div className="legacy-mapping-template-tab-container">
      <div className="section-container-sm">
        <div className="section-header">
          <Select
            showSearch={true}
            showArrow={true}
            allowClear={true}
            // value={selectedTable?.id}
            onChange={handleMappingTemplateChange}
            style={{ flex: 2 }}
            placeholder={t(
              "Page.Operation.LegacyMapping.Tabs.MappingTemplates.Placeholders.MappingTemplate",
              {
                lngs: i18n.languages,
                defaultValue: "Mapping template",
              }
            )}
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option!.children as unknown as string).includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA!.children as unknown as string)
                .toLowerCase()
                .localeCompare(
                  (optionB!.children as unknown as string).toLowerCase()
                )
            }
          >
            {mappingTemplates.map((item: any) => {
              return <Option value={item.id}>{item.name}</Option>;
            })}
          </Select>
        </div>
        <Divider />
        <div className="section-items">
          {mappingTemplates && !isTableLoading ? (
            <Menu
              items={mappingTemplates.map((item: any) => {
                return {
                  key: item.id,
                  label: item.name,
                };
              }).sort(function (a: any, b: any) {
                if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
                if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
                return 0;
              })}
              selectedKeys={[selectedMappingTemplate?.id.toString()]}
              onClick={handleMappingTemplateMenuClick}
            />
          ) : (
            <Empty description={false}></Empty>
          )}
          {isTableLoading && (
            <div className={styles.loadingContainer}>
              <Spin />
            </div>
          )}
        </div>
      </div>
      <div className="data-container" style={{overflow: "auto"}}>
        {/* {!isTableLoading ? ( */}
        {selectedMappingTemplate ? (
          <>
            <div className="title-actions">
              <div className="title-info">
                <span style={{wordBreak: "break-word"}}>{selectedMappingTemplate.name}</span>
              </div>
              <div className="header-buttons">
                <Button
                  icon={<DeleteOutlined />}
                  size="small"
                  type="ghost"
                  onClick={() =>
                    onDeleteMappingTemplate(selectedMappingTemplate.id)
                  }
                >
                  {t("General.Labels.Delete", {
                    lngs: i18n.languages,
                    defaultValue: "Delete",
                  })}
                </Button>
              </div>
            </div>
            <div className="table-container">
              {/* <Table
              locale={locale}
              dataSource={[]}
              columns={columnsTable}
              size="small"
              loading={isTableLoading}
              onRow={(record, rowIndex) => {
                return {
                  onDoubleClick: (event) => {
                    showDrawer(RowAction.View);
                    onDoubleClickRow(record);
                  },
                };
              }}
            /> */}
              {/* <Table
              style={{ width: "100%" }}
              size="small"
              columns={columns}
              dataSource={mappingTemplateMappings}
              pagination={paginationConfig}
            /> */}
              <Datatable
                scroll={scroll}
                paginationDisabled={true}
                tableColumns={[
                  {
                    key: "fromValue",
                    title: t(
                      "Page.Operation.LegacyMapping.Tabs.MappingTemplates.Table.Headers.FromValue",
                      {
                        lngs: i18n.languages,
                        defaultValue: "From Value",
                      }
                    ),
                  },
                  {
                    key: "tableName",
                    title: t(
                      "Page.Operation.LegacyMapping.Tabs.MappingTemplates.Table.Headers.ToTable",
                      {
                        lngs: i18n.languages,
                        defaultValue: "To Table",
                      }
                    ),
                  },
                  {
                    key: "fieldName",
                    title: t(
                      "Page.Operation.LegacyMapping.Tabs.MappingTemplates.Table.Headers.ToField",
                      {
                        lngs: i18n.languages,
                        defaultValue: "To Field",
                      }
                    ),
                  },
                  {
                    key: "comments",
                    title: t(
                      "Page.Operation.LegacyMapping.Tabs.MappingTemplates.Table.Headers.Comments",
                      {
                        lngs: i18n.languages,
                        defaultValue: "Comments",
                      }
                    ),
                  },
                ]}
                data={mappingTemplateMappings}
                setData={setMappingTemplateMappings}
                isTableLoading={isMappingTemplateTableLoading}
                otherActions={[]}
                otherRowEnabled={false}
                editRowEnabled={false}
                copyRowEnabled={false}
                deleteRowEnabled={false}
                onEditFunc={undefined}
                onCopyFunc={undefined}
                onDeleteFunc={undefined}
                onDoubleClickRow={undefined}
                selectable={false}
                multiSelect={false}
                selectedRows={[]}
                setSelectedRows={undefined}
                checkPermissions={true}
              ></Datatable>
            </div>
            <Drawer
              width={"400px"}
              getContainer={false}
              style={{ position: "absolute" }}
              title={drawerTitle}
              placement={DRAWER_PLACEMENTS.BOTTOM}
              onClose={onClose}
              visible={openDrawer}
              closable={false}
              extra={
                <Space>
                  {RowAction?.View === drawerAction && (
                    <>
                      <Button
                        onClick={() => showDrawer(RowAction.Edit)}
                        icon={<EditOutlined />}
                        size="small"
                      >
                        Edit
                      </Button>
                      <Button
                        type="ghost"
                        onClick={onClose}
                        icon={<CloseOutlined />}
                        size="small"
                      />
                    </>
                  )}
                </Space>
              }
            >
              <Form
                disabled={RowAction.View === drawerAction ? true : false}
                layout="inline"
                // wrapperCol={{ span: 12 }}
                labelCol={{ span: 12 }}
              ></Form>
            </Drawer>
          </>
        ) : (
          <div className="empty-container">
            <Empty
              style={{ display: "flex", width: "100%" }}
              description={t(
                "Page.Operation.LegacyMapping.Tabs.MappingTemplates.Tutorial.GetStarted",
                {
                  lngs: i18n.languages,
                  defaultValue:
                    "Please select a Mapping template on the left to get started",
                }
              )}
            ></Empty>
          </div>
        )}
        {/* ) : (
        <div className="empty-container">
          <Empty description={false} />
        </div>
        )} */}
      </div>
    </div>
  );
};

export default MappingTemplate;
